export const lang = {
    home: "知识库",
    account: {
        title: "账号",
        vip: {
            title: "VIP",
            url: "../../static/img/zh/0.png"
        },
        forget: {
            title: "忘记账号密码",
            url: "../../static/img/zh/1.png"
        },
        active: {
            title: "活跃指数",
            url: "../../static/img/zh/2.png"
        }
    },
    props: {
        title: "道具",
        history: {
            title: "历史记录",
            url: "../../static/img/zh/3.png"
        },
        bag: {
            title: "福袋",
            url: "../../static/img/zh/4.png"
        },
        backpack: {
            title: "背包",
            url: "../../static/img/zh/5.png"
        },
        card: {
            title: "虚宝卡",
            url: "../../static/img/zh/6.png"
        }
    },
    chat: {
        title: "聊天",
        big: {
            title: "大声公",
            url: "../../static/img/zh/7.png"
        },
        push: {
            title: "群长推播",
            url: "../../static/img/zh/8.png"
        },
        red: {
            title: "群长红包",
            url: "../../static/img/zh/9.png"
        },
        chat: {
            title: "聊天",
            url: "../../static/img/zh/10.png"
        }
    },
    game: {
        title: "游戏",
        keep: {
            title: "保留座",
            url: "../../static/img/zh/11.png"
        },
        scratch: {
            title: "刮刮乐",
            url: "../../static/img/zh/12.png"
        },
        jackpot: {
            title: "连线彩金",
            url: "../../static/img/zh/13.png"
        },
        choice: {
            title: "选座大厅",
            url: "../../static/img/zh/14.png"
        }
    },
    bank: {
        title: "银行",
        forgetPass: {
            title: "忘记赠礼密码",
            url: "../../static/img/zh/15.png"
        },
        trade: {
            title: "赠礼",
            url: "../../static/img/zh/16.png"
        },
        tradeList: {
            title: "赠礼名单",
            url: "../../static/img/zh/17.png"
        },
        tradeLimit: {
            title: "赠礼限制",
            url: "../../static/img/zh/18.png"
        }
    }
}


// WEBPACK FOOTER //
// ./src/i18n/zh.js